import React from 'react';
import PropTypes from 'prop-types';

const NotificationsOffPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M12.033 4.955C12.472 3.153 14.12 1.833 16 1.833a4.055 4.055 0 0 1 3.963 3.122c.897.366 1.726.85 2.47 1.431L4.818 24H2.583a.583.583 0 0 1 0-1.167A2.92 2.92 0 0 0 5.5 19.917v-5.25c0-4.249 2.612-8.11 6.533-9.712zm15.634-2.036a.5.5 0 0 1 .708 0l.706.706a.5.5 0 0 1 0 .708L4.333 29.082a.5.5 0 0 1-.707 0l-.708-.708a.5.5 0 0 1 0-.707L27.667 2.919zM11.182 24l14.14-14.139a10.427 10.427 0 0 1 1.178 4.806v5.25a2.92 2.92 0 0 0 2.917 2.916.584.584 0 0 1 0 1.167H11.182zm1.318 2h7c.322 0 .583.261.583.583A4.088 4.088 0 0 1 16 30.667a4.089 4.089 0 0 1-4.084-4.084c0-.322.262-.583.584-.583z"
    />
  );
};

NotificationsOffPath.propTypes = {
  fill: PropTypes.string,
};

export default NotificationsOffPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/features-navigation/notifications-off.jsx